import type { MRT_ColumnFiltersState } from "mantine-react-table";
import { describeActiveFilters } from "./describeActiveFilters";
import type { ChatContextFilters } from "./pendingChatContext";

export const buildChatContextFromFilters = ({
    columnFilters,
    labelById,
}: {
    columnFilters: MRT_ColumnFiltersState;
    labelById?: Map<string, string>;
}): ChatContextFilters => {
    const activeFilters = describeActiveFilters({ columnFilters, labelById });
    return {
        metadataFilter: activeFilters.map((filter) => ({ key: filter.label, value: filter.value })),
        contextTags: activeFilters.map((filter) => ({ label: filter.label, value: filter.value })),
    };
};
